import clsx from 'clsx';
import { useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import BorrowerUpdateProfile from '../components/AccountSetting/BorrowerUpdateProfile';
import ChangePassword from '../components/AccountSetting/ChangePassword';
import EditProfile from '../components/AccountSetting/EditProfile';
import ProviderUpdateProfile from '../components/AccountSetting/ProviderUpdateProfile';
import { UserTypeId, USER_KEY } from '../helpers/constants';
import history from '../helpers/history';
import { AuthenthicatedUserInfo } from '../interfaces';
import Page from '../layout/components/Page';

const SettingsPage = () => {
  const { menu } = useParams<{ menu: string }>();
  const { pathname } = useLocation<{ pathname: string }>();

  const user: AuthenthicatedUserInfo = JSON.parse(localStorage.getItem(USER_KEY)!);
  const isBorrower = user.user.user_type_id === UserTypeId.BORROWER;

  const makeActive = (path: string) => {
    const splitLocation = pathname.split('/');

    if (splitLocation[2]) {
      return splitLocation[2] === path ? 'current' : '';
    }
    return '';
  };

  useEffect(() => {
    if (!menu) {
      history.push('/settings/profile');
    }
  }, [menu]);

  const UpdateComponent = isBorrower ? BorrowerUpdateProfile : ProviderUpdateProfile;

  const renderComponent = () => {
    if (menu === 'change-password') {
      return <ChangePassword />;
    } else if (menu === 'update-profile') {
      return <UpdateComponent />;
    } else {
      return <EditProfile />;
    }
  };

  return (
    <Page title='Account Settings' icon='bi-gear'>
      <div className='card'>
        <div className='card-body'>
          <div className='stepper stepper-links d-flex flex-column'>
            <div className='stepper-nav mb-5'>
              <div className={clsx('stepper-item', makeActive('profile'))} data-kt-stepper-element='nav'>
                <Link to='/settings/profile'>
                  <h6>Profile</h6>
                </Link>
              </div>
              <div className={clsx('stepper-item', makeActive('change-password'))} data-kt-stepper-element='nav'>
                <Link to='/settings/change-password'>
                  {' '}
                  <h6>Change Password</h6>
                </Link>
              </div>
              {user.user.user_type_id !== UserTypeId.INVESTOR && (
                <div className={clsx('stepper-item', makeActive('update-profile'))} data-kt-stepper-element='nav'>
                  <Link to='/settings/update-profile'>
                    {' '}
                    <h6>Update Profile</h6>
                  </Link>
                </div>
              )}
            </div>

            <div className='mx-auto mw-600px w-100 pt-10 pb-10'>{renderComponent()}</div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default SettingsPage;
